import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, empty, throwError, TimeoutError } from 'rxjs';
import { timeout, map, catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from './datastore.service';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  loadIssue;

  constructor(
    private DataStore: DatastoreService,
    private spinner: NgxSpinnerService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      timeout(60000),
      map((res) => {
        return res;
      }),
      catchError((err) => {
        console.log(err);
        // /fees must fail loudly: a 404 there means "this cannot be priced" —
        // fees() logs the reason and rethrows so the journey blocks instead of
        // selling an unpriced ceremony at £0. The legacy empty() below would
        // make fees() resolve to undefined and that guard would never fire.
        if (/\/fees(\?|$)/.test(request.url)) {
          this.spinner.hide();
          return throwError(() => err);
        }
        // Payment-setup calls must see the real error: the pre-basket gate
        // answers 409 with a machine-readable reason, and the summary
        // component's recovery flow branches on it. Swallowing it into an
        // empty response (the legacy behaviour below) made a deliberate
        // payment block indistinguishable from a network blip.
        if (request.url.indexOf('/payment/hey-centric/') !== -1) {
          this.spinner.hide();
          return throwError(err);
        }
        // A reference lookup that finds nothing answers 404, and that is a
        // routine outcome — the user mistyped, or their form submission isn't
        // there. Let it through so the field can show its own inline message.
        // The legacy empty() below would instead scroll the page to the top
        // and raise the global "problem loading" banner (RWRSPI-1088). Only a
        // 404 is routine: an outage or a timeout still deserves that banner,
        // rather than being reported to the user as their own typo.
        if (request.url.indexOf('/formsubmissions/') !== -1 && err?.status === 404) {
          this.spinner.hide();
          return throwError(() => err);
        }
        // The WCC postcode API answers 500 for a postcode it does not know.
        // Let the error through so the field shows "invalid postcode" next to
        // the Find address button, instead of the global banner that a later
        // good search never clears (RWRSPI-1104).
        if (request.url.indexOf('/locations/v1/postcode') !== -1) {
          this.spinner.hide();
          return throwError(() => err);
        }
        this.DataStore.onNotify(true);
        this.spinner.hide();
        if (err instanceof TimeoutError) {
          console.error('Timeout has occurred', request.url);
        }
        return empty();
      })
    );
  }
}
